<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="Servers" :active="true"/>
		</b-breadcrumb>
		<b-container fluid>
			<b-row>
				<b-col>
					<b-form-group id="owner-group">
						<b-input-group>
							<b-form-input v-model="filter" placeholder="Type to Search" @input="pageChange()"></b-form-input>
							<b-input-group-append>
								<b-button variant="primary" to="/servers/add">Add</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="auto">
					<b-form-radio-group id="display-mode" v-model="displayMode" :options="displayModeOptions" buttons button-variant="outline-primary" name="display-mode">
					</b-form-radio-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<table class="table table-striped table-hover" v-if="displayMode === 'table'">
						<thead>
							<tr>
								<th>Name</th>
								<th>Group</th>
								<th>Hostname</th>
								<th>RAM</th>
								<th>Disk</th>
								<th>Color</th>
								<th>Visible</th>
								<th>Enabled</th>
								<th>Status</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in items">
								<td><b-link @click="viewServer(item.id)">{{item.name}}</b-link></td>
								<td>{{item.group}}</td>
								<td>{{item.hostname}}</td>
								<td>{{item.metrics.memory.free | size}} / {{item.metrics.memory.free + item.metrics.memory.used | size}} ({{item.metrics.memory.usage | percentage}})</td>
								<td>{{item.metrics.disk.free | size}} / {{item.metrics.disk.free + item.metrics.disk.used | size}} ({{item.metrics.disk.usage | percentage}})</td>
								<td>
									<b-form-input type="color" v-model="item.color" :readonly="true" :disabled="true"></b-form-input>
								</td>
								<td>
									<icon v-if="item.visible == true" name="eye"/>
									<icon v-if="item.visible == false" name="eye-slash"/>
								</td>
								<td>
									<icon v-if="item.enabled == true" name="check"/>
									<icon v-if="item.enabled == false" name="ban"/>
								</td>
								<td>
									<b-badge :variant="item.status === 'RUNNING' ?'success': ''">{{item.status}}</b-badge>
								</td>
								<td align="right">
									<b-button-toolbar>
										<b-button-group>
											<b-button variant="outline" v-if="item.visible == false" @click="setVisible(item.id, true)" v-b-tooltip.hover title="Show"><icon name="eye" style="color: #777"></icon></b-button>
											<b-button variant="outline" v-if="item.visible == true" @click="setVisible(item.id, false)" v-b-tooltip.hover title="Hide"><icon name="eye-slash" style="color: #777"></icon></b-button>
											<b-button variant="outline" v-if="item.enabled == false" @click="setEnable(item.id, true)" v-b-tooltip.hover title="Enable"><icon name="check" style="color: #777"></icon></b-button>
											<b-button variant="outline" v-if="item.enabled == true" @click="setEnable(item.id, false)" v-b-tooltip.hover title="Disable"><icon name="ban" style="color: #777"></icon></b-button>
											<b-button variant="outline" :disabled="item.enabled == false" @click="startMonitor(item.id)" v-b-tooltip.hover title="Start"><icon name="play" style="color: #777"></icon></b-button>
											<b-button variant="outline" :disabled="item.enabled == false" @click="stopMonitor(item.id)" v-b-tooltip.hover title="Stop"><icon name="stop" style="color: #777"></icon></b-button>
											<b-button variant="outline" @click="refreshServer(item.id)" v-b-tooltip.hover title="Refresh"><icon name="sync" style="color: #777"></icon></b-button>
											<b-button variant="outline" @click="deleteServer(item.id)" v-b-tooltip.hover title="Delete"><icon name="trash" style="color: #777"></icon></b-button>
										</b-button-group>
									</b-button-toolbar>
								</td>
							</tr>
						</tbody>
					</table>
					<b-list-group v-if="displayMode === 'list'">
						<b-list-group-item @click="viewServer(item.id)" v-for="item in items">
							<div class="d-flex w-100 justify-content-between">
								<h5 class="mb-1">{{item.name}}</h5>
								<small>
									<icon v-if="item.visible == true" name="eye" v-b-tooltip.hover title="Visible"/>
									<icon v-if="item.visible == false" name="eye-slash" v-b-tooltip.hover title="Hidden"/>
									<icon v-if="item.enabled == true" name="check" v-b-tooltip.hover title="Enabled"/>
									<icon v-if="item.enabled == false" name="ban" v-b-tooltip.hover title="Disabled"/>
									<b-badge :variant="item.status === 'RUNNING' ?'success': ''">{{item.status}}</b-badge>
								</small>
							</div>
							<p class="mb-1">
								{{item.description}}
							</p>
							</small>
							<div class="float-right">
								<b-button-toolbar>
									<b-button-group>
										<b-button variant="outline" size="sm" @click="deleteServer(item.id)" v-b-tooltip.hover title="Delete"><icon name="trash"></icon></b-button>
									</b-button-group>
								</b-button-toolbar>
							</div>
						</b-list-group-item>
					</b-list-group>
				</b-col>
			</b-row>
			<div class="d-flex flex-row mt-3">
				<div class="">{{totalItems}} Servers</div>
				<div class="ml-auto">
					<b-pagination size="md" :total-rows="totalItems" :per-page="rowsPerPage" v-model="pageNo" @input="pageChange()"/>
				</div>
				<div>
					<b-form-select :options="[{text:10,value:10},{text:25,value:25},{text:50,value:50},{text:100,value:100}]" v-model="rowsPerPage" @input="pageChange()"/>
				</div>
			</div>
		</b-container>
	</div>
</template>
<script>
import {HTTP} from '../../services/HttpService'

export default {
  name: 'servers',
  data: () => ({
    displayMode: 'table',
    displayModeOptions: [
      { text: 'List', value: 'list' },
      { text: 'Table', value: 'table' }
    ],
    items: [],
    pageNo: 1,
    rowsPerPage: 10,
    totalItems: 0,
    filter: null
  }),
  methods: {
    pageChange () {
      HTTP.get('servers', {
        params: {
          page: this.pageNo - 1,
          rowsPerPage: this.rowsPerPage,
          search: this.filter
        }
      })
      .then(response => {
        this.items = response.data.list
        this.rowsPerPage = response.data.rowsPerPage
        this.totalItems = response.data.totalItems
      })
    },
    refreshServer (serverId) {
      HTTP.post('servers/' + serverId + '/refresh')
      .then(response => {
        this.pageChange()
      })
    },
    deleteServer (serverId) {
      HTTP.delete('servers/' + serverId)
      .then(response => {
        this.pageChange()
      })
    },
    startMonitor (serverId) {
      HTTP.post('servers/' + serverId + '/agent/start')
      .then(response => {
        this.pageChange()
      })
    },
    stopMonitor (serverId) {
      HTTP.post('servers/' + serverId + '/agent/stop')
      .then(response => {
        this.pageChange()
      })
    },
    setEnable (serverId, status) {
      HTTP.post('servers/' + serverId + '/enable?enable=' + status)
      .then(response => {
        this.pageChange()
      })
    },
    setVisible (serverId, visible) {
      HTTP.post('servers/' + serverId + '/visible?visible=' + visible)
      .then(response => {
        this.pageChange()
      })
    },
    viewServer (serverId) {
      this.$router.push({
        name: 'ServerDetailsPage',
        params: {
          serverId: serverId
        }
      })
    }
  },
  created () {
    this.pageChange()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ServersPage.vue?08ffe8a9